import styled from "styled-components";

export const Flex = styled.div`
  display: flex;
  max-height: 11rem;

  & > div {
    flex-grow: 1;

    &.header-horizontal {
      max-width: 24.9rem;
    }
  }

  .drawerHeader {
    max-width: 24.9rem;
    background: #f3f3f3;
    border-right: 1px solid rgba(0, 0, 0, 0.12);

    .avatar-header {
      flex-grow: 0;
      border: 1px solid rgba(0, 0, 0, 0.3);
    }

    .truncate-name {
      color: rgba(0, 0, 0, 0.75);
      font-weight: 600;

      span {
        font-weight: normal;
      }
    }

    .dados-usuario small {
      color: rgba(0, 0, 0, 0.5);
    }
  }

  .null-bar {
    background-color: #f5f5f5;
    height: 4.8rem;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    display: flex;
    align-items: center;
    padding: 0 2rem;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;

      li {
        position: relative;

        &:not(:last-child) {
          margin-right: 3rem;

          &:after {
            width: 1px;
            height: 1.3rem;
            background: rgba(0, 0, 0, 0.3);
            content: "";
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -0.65rem;
            right: -1.5rem;
          }
        }

        a {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          color: rgba(0, 0, 0, 0.7);
          font-size: 1.15rem;

          i {
            font-size: 1.6rem;
          }
        }
      }
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f3f3f3;
  align-items: center;
  padding: 0 2rem;
  max-height: 6.1rem;
  min-height: 6.1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  justify-content: space-between;

  div {
    flex-grow: 0 !important;
    display: flex;
    align-items: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/HeaderMenuHorizontal/styles.js